import axios from 'axios'

const Helpers = {}

Helpers.config = {
  folder_path: process.env.NODE_ENV === 'production' ? window.pathFolder : process.env.REACT_APP_FOLDER_PATH,
  isProduction: process.env.NODE_ENV === 'production',
  api: {
    url: process.env.NODE_ENV === 'production' ? window.pathUrl : process.env.REACT_APP_API_URL,
    resources: process.env.NODE_ENV === 'production' ? window.pathUrlAssets : process.env.REACT_APP_RESOURCES_URL
  },
  company: {
    name: process.env.NODE_ENV === 'production' ? window.pathCompanyName : process.env.REACT_APP_COMPANY_NAME
  },
  apiUrl: ({ url = ''  } = {}) => Helpers.config.api.url + url,
  convertUrl: ({ url = '' } = {}) => Helpers.config.folder_path + url,
  resourcesUrl: ({ url = ''  } = {}) => Helpers.config.api.resources + url,
  pointMinRange: 3300,
  percentageIva: 0.16
}

Helpers.axios = ({ method = 'GET', url = '', data = {}, hasFile = false }) => {
  let urlReq = method === 'GET' ? url + '?jwt=' + Helpers.localStorage.getJWT() : url
  let bodyReq
  if  (method === 'POST') {
    if (hasFile) {
      bodyReq = data
      bodyReq.append('jwt', Helpers.localStorage.getJWT())
    } else {
      bodyReq = { ...data }
      bodyReq.jwt = Helpers.localStorage.getJWT()
    }
  }
  let config = {
    method,
    url: Helpers.config.api.url + urlReq,
    data: bodyReq,
    timeout: 15000
  }

  if (hasFile) {
    config.headers = { 'content-type': 'multipart/form-data' }
  }
  
  return new Promise((resolve, reject) => {
    axios(config).then(res => {
      return res.data
    }).then(res => {
      /* if (!Helpers.config.isProduction) {
        console.log(res)
      } */
      if (res.message === 'error_session_api') {
        Helpers.localStorage.clearJWT();
        window.location.href = Helpers.config.folder_path + '/'
        return
      }
      if (res.hasOwnProperty('data')) {
        resolve(res)
      } else {
        reject({
          response: 'danger',
          message: 'No se ha podido realizar la conexión al servidor. Contacte con el área de IT.'
        })
      }
    }).catch(req => {
      /* if (!Helpers.config.isProduction) {
        console.log(req)
      } */
      reject({
        response: 'danger',
        message: 'No se ha podido realizar la conexión al servidor. Contacte con el área de IT.'
      })
    })
  })
}

Helpers.promise = {}
Helpers.promise.catch = ({ req = {}, toast = {}}) => {
  /* if (!Helpers.config.isProduction) {
    console.log(req)
  } */
  if (req.response) {
    Helpers.toast.construct({response: req.response, message: req.message, toast})
  } else {
    Helpers.toast.construct({response: 'error', message: 'No se ha podido realizar la conexión al servidor. Contacte con el área de IT.', toast})
  }
}

Helpers.toast = {
  options: (options) => {
    return {
      autoClose: 5000,
      hideProgressBar: false,
      pauseOnHover: true,
      ...options
    }
  },
  construct: ({ response = '', message = '', toast = {}, options = {} }) => {
    if (response === 'success') {
      toast.success(message, Helpers.toast.options(options))
    } else if (response === 'info') {
      toast.info(message, Helpers.toast.options(options))
    } else if (response === 'warning') {
      toast.warning(message, Helpers.toast.options(options))
    } else {
      toast.error(message, Helpers.toast.options(options))
    }
  }
}

Helpers.localStorage = {
  name: 'session_system_devs',
  legacyName: 'session_react_tonic_life',
  getSession: () => {
    try {
      const current = localStorage.getItem(Helpers.localStorage.name)
      const legacy = localStorage.getItem(Helpers.localStorage.legacyName)
      return JSON.parse(current || legacy || 'null')
    } catch (error) {
      Helpers.localStorage.clearJWT()
      return null
    }
  },
  exists: () => {
    try {
      return localStorage.getItem(Helpers.localStorage.name) || localStorage.getItem(Helpers.localStorage.legacyName)
    } catch (error) {
      return null
    }
  },
  existsJWT: () => {
    if (Helpers.localStorage.exists()) {
      const session = Helpers.localStorage.getSession()
      if (session && session.jwt) {
        return true
      }
    }
    return false
  },
  setSession: (session) => {
    try {
      localStorage.removeItem(Helpers.localStorage.legacyName)
      localStorage.setItem(Helpers.localStorage.name, JSON.stringify(session))
    } catch (error) {
      // Algunos modos privados restringen almacenamiento; el login debe seguir visible.
    }
  },
  getJWT: () => Helpers.localStorage.existsJWT() ? Helpers.localStorage.getSession().jwt : '',
  clearJWT: () => {
    try {
      localStorage.removeItem(Helpers.localStorage.name)
      localStorage.removeItem(Helpers.localStorage.legacyName)
    } catch (error) {
      // No bloquear la interfaz si el navegador restringe localStorage.
    }
  }
}

Helpers.date = {
  get: ({ format = '%Y-%m-%d', addDays = 0, startDate = new Date() } = {}) => {
    let date = startDate
    if (addDays !== 0) {
      date.setDate(date.getDate() + addDays)
    }

    let d = {
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
      hours: date.getHours(),
      minutes: date.getMinutes()
    }
    let dateTex = format.replace('%Y', d.year)
    .replace('%m', (d.month + 1 < 10 ? '0' : '') + (d.month + 1))
    .replace('%d', (d.day < 10 ? '0' : '') + d.day)
    .replace('%H', (d.hours < 10 ? '0' : '') + d.hours)
    .replace('%i', (d.minutes < 10 ? '0' : '') + d.minutes)

    return dateTex
  },
  getToday: ({ format = '%Y-%m-%d', ...params } = {}) => {
    return Helpers.date.get({ format, ...params })
  }
}

Helpers.number = {
  float: {
    format: ({ number } = {}) => {
      return parseFloat(number).toLocaleString('es-MX', { minimumFractionDigits: 2 })
    }
  }
}

Helpers.string = {
  toCamelCase: str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

Helpers.getActions = ({ permissions, module }) => {
  let actions = {}
  permissions.forEach(tpm => {
      tpm.childrens.forEach(tp => {
          tp.childrens.forEach(t => {
              if (t.a_href === module) {
                  t.actions.forEach(a => {
                      actions[a.field_action] = a
                  })
              }
          })
      })
  })
  return actions
}

Helpers.defaultImage = ({ image }) => {
  if (!image) {
    return Helpers.config.resourcesUrl({
      url: '/images/dashboard/sin_imagen.png'
    })
  }

  return Helpers.config.resourcesUrl({
    url: image
  })
}

Helpers.print = {
  construct: ({ selector, title, addHtml = '' } = {}) => {
    const mywindow = window.open('', 'PRINT', 'height=1000,width=1000');

    mywindow.document.write(`<html>
      <head>
        <title>${title}</title>
        ${document.querySelector('head').innerHTML}
      </head>
      <body>
        ${document.querySelector(selector).innerHTML}
        ${addHtml}
      </body>
    </html>`);

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    mywindow.close();
  }
}


export default Helpers
